<template>
  <div class="w-100" :class="dynamicClass">
    {{ formattedContent }}
  </div>
</template>

<script>
export default {
  name: 'DateField',
  props: {
    content: {
      type: String,
    },
    type: {
      type: String,
    },
    fieldName: {
      type: String,
    },
    inDetailView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getDateFormat() {
      let format = ''
      switch (this.$CORE.language.code) {
        case 'en-US': {
          format = 'MM/DD/yyyy'
          break
        }
        case 'hu-HU':
        case 'de-DE': {
          format = 'yyyy-MM-DD'
          break
        }
        default: {
          format = 'DD/MM/yyyy'
          break
        }
      }
      return format
    },
    dynamicClass() {
      return this.inDetailView || this.isCardView ? 'text-start' : 'text-center'
    },
    formattedContent() {
      let momentDate = this.content
      let formattedDate
      let hours, minutes, seconds
      switch (this.type) {
        case 'date': {
          formattedDate = this.$moment.utc(momentDate).format(this.getDateFormat)
          break
        }
        case 'time': {
          ;[hours, minutes, seconds] = momentDate.split(':')
          formattedDate = new Date(null, null, null, hours, minutes, seconds).toLocaleTimeString(this.locale)
          break
        }
        default: {
          formattedDate = this.$moment.utc(momentDate).format(`${this.getDateFormat} HH:mm:ss`)
        }
      }
      return formattedDate
    },
    isCardView() {
      return this.$get('viewMode') === 'cardView'
    },
    locale() {
      return this.$CORE.language.code
    },
  },
}
</script>
